module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "icons.7ee4a911.svg";